import { Construction } from "lucide-react";

// Shared Leads-Dialer visual primitives for the Clients Dialer.
export const SL = { fontSize: 10, fontWeight: 600, color: "#888", textTransform: "uppercase", letterSpacing: "0.4px" };

export const STATUS_STYLES = {
  active: { border: "#1D9E75", bg: "#DAFBE8", color: "#1D9E75" },
  paused: { border: "#BA7517", bg: "#FFF3CD", color: "#856404" },
  archived: { border: "#A32D2D", bg: "#FCEBEB", color: "#A32D2D" },
};

export function WipNote({ children, testid }) {
  return (
    <div data-testid={testid} style={{ display: "flex", alignItems: "center", gap: 6, marginTop: 6, padding: "6px 10px", borderRadius: 8, background: "#FAEEDA", color: "#854F0B", fontSize: 11, border: "0.5px solid #F3D9A9" }}>
      <Construction style={{ width: 12, height: 12, flexShrink: 0 }} /> {children}
    </div>
  );
}

export function EmptyState({ testid, children }) {
  return (
    <div data-testid={testid} style={{ padding: "32px 20px", textAlign: "center", color: "var(--text-tertiary)", fontSize: 12, border: "1px dashed var(--border)", borderRadius: 10 }}>
      {children}
    </div>
  );
}

export function ComingSoon({ title, testid }) {
  return (
    <div data-testid={testid} style={{ padding: "48px 20px", textAlign: "center", border: "1px dashed var(--border)", borderRadius: 10, background: "#fff" }}>
      <div style={{ width: 44, height: 44, borderRadius: "50%", background: "#FAEEDA", display: "inline-flex", alignItems: "center", justifyContent: "center", marginBottom: 12 }}>
        <Construction style={{ width: 20, height: 20, color: "#854F0B" }} />
      </div>
      <div style={{ fontSize: 14, fontWeight: 600, color: "var(--navy, #0F2942)", marginBottom: 4 }}>{title} — coming soon</div>
      <div style={{ fontSize: 12, color: "var(--text-tertiary)", maxWidth: 420, margin: "0 auto" }}>
        This area is a work in progress for the Clients Dialer and will be added later.
      </div>
    </div>
  );
}

export function SkeletonRows({ testid = "cd-campaigns-loading" }) {
  return (
    <div data-testid={testid} style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      {[0, 1, 2].map((i) => (
        <div key={i} data-testid={`cd-skeleton-${i}`} style={{ background: "#fff", borderRadius: 10, border: "0.5px solid #eee", borderLeft: "4px solid #e5e7eb", padding: "14px 18px", display: "flex", alignItems: "center", gap: 14 }}>
          <div className="skeleton" style={{ width: 14, height: 14, borderRadius: 4, flexShrink: 0 }} />
          <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: 8 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <div className="skeleton" style={{ width: 160, height: 14, borderRadius: 4 }} />
              <div className="skeleton" style={{ width: 52, height: 16, borderRadius: 10 }} />
              <div className="skeleton" style={{ width: 64, height: 16, borderRadius: 10 }} />
            </div>
            <div className="skeleton" style={{ width: 220, height: 10, borderRadius: 4 }} />
          </div>
        </div>
      ))}
    </div>
  );
}

export function ChipBtn({ active, onClick, children, testid }) {
  return (
    <button type="button" data-testid={testid} onClick={onClick}
      style={{ padding: "4px 11px", borderRadius: 999, fontSize: 11, fontWeight: 500, border: active ? "0.5px solid #cfe2ff" : "0.5px solid var(--border)", background: active ? "var(--blue-soft)" : "var(--paper)", color: active ? "var(--blue)" : "var(--text-3)", cursor: "pointer", fontFamily: "inherit", transition: "background-color 120ms ease, color 120ms ease, border-color 120ms ease" }}>
      {children}
    </button>
  );
}

export function FieldGroup({ eyebrow, hint, children }) {
  return (
    <div>
      <div style={{ display: "flex", alignItems: "baseline", justifyContent: "space-between", marginBottom: 6 }}>
        <span className="eyebrow">{eyebrow}</span>
        {hint && <span style={{ fontSize: 10, color: "var(--text-4)" }}>{hint}</span>}
      </div>
      {children}
    </div>
  );
}

export function SectionCard({ title, children }) {
  return (
    <div className="card" style={{ padding: 14, border: "0.5px solid var(--border)" }}>
      <div style={{ fontFamily: "var(--font-head)", fontSize: 12, fontWeight: 600, color: "var(--navy)", marginBottom: 10, letterSpacing: "-0.005em" }}>{title}</div>
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>{children}</div>
    </div>
  );
}

export const initials = (name) => (name || "").split(" ").map((n) => n[0]).join("").slice(0, 2).toUpperCase();
